export default "__VITE_PUBLIC_ASSET__e8b17a82__"